<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import loadingVue from "@/components/loading.vue";
import subProgramme from "./sub_programme.vue";
import subLatihan from "./sub_latihan.vue";
import programmeQuestions from "./programme_questions.vue";

/**
 * Starter page
 */
export default {
  components: {
    Layout,
    loadingVue,
    subProgramme,
    subLatihan,
    programmeQuestions,
    // Carousel,
  },
  page: {
    title: "Student",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "CBT - Siswa",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Student",
          active: true,
        },
      ],
      programmeName: this.$route.params.programname,
      isLoading: true,
      errorMessage: false,
    };
  },
  mounted() {
    this.isLoading = false;
  },

  computed: {},

  methods: {},
  middleware: "authentication",
};
</script>

<style scoped>
.bg-custom {
  background-color: var(--bs-indigo);
}
.border-custom {
  border-color: #adb5bd !important;
}
.custom-select {
  padding: 0.75rem !important;
  font-size: 1rem !important;
}
</style>

<template>
  <Layout>
    <b-breadcrumb>
      <b-breadcrumb-item>
        <router-link to="/">
          <b-icon
            class="me-2"
            icon="house-fill"
            scale="1.25"
            shift-v="1.25"
            aria-hidden="true"
          ></b-icon>
          Home
        </router-link>
      </b-breadcrumb-item>
      <b-breadcrumb-item class="text-capitalize">
        {{ programmeName }}
      </b-breadcrumb-item>
    </b-breadcrumb>

    <div v-if="errorMessage" class="alert alert-danger" role="alert">
      <h1 align="center">
        Anda tidak mempunyai akses pada halaman ini, Silahkan Klik dibawah ini.
      </h1>
    </div>
    <div v-if="errorMessage" class="logout w-25 mx-auto" align="center">
      <a class="dropdown-item" href="/logout">
        <i
          class="uil uil-sign-out-alt font-size-18 align-middle me-1 text-muted"
        ></i>
        <span class="align-middle">{{
          $t("navbar.dropdown.marcus.list.logout")
        }}</span>
      </a>
    </div>

    <div v-if="isLoading !== true">
      <template v-if="programmeName === 'polri' || programmeName === 'ipdn'">
        <subProgramme />
      </template>

      <template v-else-if="programmeName === 'latihan'">
        <subLatihan />
      </template>

      <template v-else>
        <programmeQuestions />
      </template>
    </div>

    <div
      style="height: 74vh;"
      class="d-flex justify-content-center align-items-center"
      v-else
    >
      <loading-vue></loading-vue>
    </div>
  </Layout>
</template>
